import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './UnitedNations.css';
import './AboutPages.css';

import chairmanImg from '../images/chairman.png';
import viceChairmanImg from '../images/vice chairman.png';
import presidentImg from '../images/president.png';
import vpEmeritaaImg from '../images/emritha.jpeg';

import gdSinghImg from '../images/prof.dr.sir GD singh.png';
import drRomeshImg from '../images/hh prof.dr.sir.romesh.png';
import mrsCharmaineImg from '../images/msr.chamaine.png';

const DEFAULT_LEADERSHIP = [
  {
    id: 'lead-1',
    role: 'Chairman',
    name: 'His Eminence Prof. Dr. Sir Madhu Krishan',
    titleDetails: '',
    image: chairmanImg,
    bio: [
      'His Eminence Prof. Dr. Madhu Krishan is an Engineer, Scientist and Global Diplomat who is the Founder and Chairman of the Academy of Universal Global Peace- AUGP which is registered with the United Nations. AUGP is affiliated with DMPP Albania, United Nations, United Nations Global Compact & European Commission and World Peace Organization. He is also the President and Rector of United Nations University For Global Peace.',
      'Dr.Madhu is the Honorary Chairman & Goodwill Ambassador of Diplomatic Mission Peace And Prosperity – Albania; Ambassador of The Kingdom of Buyoro – Kitara (ARKBK) – Uganda; Ambassador of International Blue Cross – United Kingdom; Ambassador of World Parliament of Peace & Security.',
      'He has won several awards, such as, Bharath Excellence Award and Gold Medal 2006, Rashtriya Jewel Award and Gold Medal 2006 & the first ever Indian to get "USA President\'s Life Time Achievement Award" For 30 years of dedicated services in more than 77 countries. Earlier he received the best scientist award from USA.'
    ]
  },
  {
    id: 'lead-2',
    role: 'Vice Chairman',
    name: 'Prof. Dr. Sir Lakshman Madurasinghe',
    titleDetails: '',
    image: viceChairmanImg,
    bio: [
      'Prof. Dr Lakshman Madurasinghe is a Lawyer, Behavioural Scientist, Educationist, Strategist and Author of four books including Clinical Psychology, Buddhism & Christianity. He is an Academic Board Member of EDU Brussels accredited to European Parliament and the Chancellor of the United Nations University For Global Peace and Vice Chancellor of AUGP.',
      'He is an Ambassador at Large in United Refugee Green Council and a Consultant on socioeconomic development to Vassili Group in Cyprus, EU. He is the Chairman of the Eco-tourism Development project, Chairman infrastructural funding and Vice Chairman of Way to Comfort NGO.',
      'He is a life member of the Cambridge University Society of Cambridge University, England, and its former Treasurer in Sri Lanka: World Jurists Association, USA: International Council of Psychologists, USA and Institute of Counselling, Glasgow.'
    ]
  },
  {
    id: 'lead-3',
    role: 'President',
    name: 'Dr. Tharindu Wijenayake',
    titleDetails: 'GG, AJP GIA (London), M.B.A (London): D Dipl&SD (USA)',
    image: presidentImg,
    bio: [
      'Dr. Tharindu Wijenayake is an Entrepreneur, Gemologist, Philanthropist and a young energetic youth leader. He hails from a generation of patrons of social services done with their own will & funds for the Sri Lankan society. Heading the WCM youth ministry and media he is a mentor to thousands of youth.',
      'A catalyst for change to foster & promote the well-being of communities. International President- United Nations Global Development Organization – USA, Registered with United Nations, Vice Chairman- Sanasumata Maga (Way To Comfort) NGO, International Director of Youth Affairs- Academy Of Universal Global Peace – USA, Registered With United Nations, CEO- Kavinda Enterprises Pvt Ltd, Director General- WCM Media, Regional head Sri Lanka – World Peace & Diplomacy Organization (WPDO).'
    ]
  },
  {
    id: 'lead-4',
    role: 'Vice President',
    name: 'Dr. Emeritaa Wijenayake (Fernando)',
    titleDetails: '',
    image: vpEmeritaaImg,
    bio: [
      'Dr. Emeritaa Wijenayake (Fernando) serves as Vice President of the United Nations Global Development Organization (UNGDO), distinguished by a multidisciplinary career encompassing entrepreneurship, strategic communications, international events, media, business development, and the creative industries.',
      'Her professional journey reflects a commitment to visionary leadership, innovation, international engagement, and meaningful social impact. With a strong aptitude for strategic relationship-building and public representation, Dr. Emeritaa engages with diverse professional and international communities to foster collaboration and create new avenues for opportunity.',
      'In her leadership capacity at UNGDO, Dr. Emeritaa is dedicated to advancing sustainable development, entrepreneurship, education, empowerment, and inclusive growth, with particular emphasis on initiatives that inspire women and youth to become catalysts for positive and lasting change.'
    ]
  }
];

const DEFAULT_INTL_GOVERNORS = [
  {
    id: 'gov-1',
    role: 'International Governor',
    name: 'Prof. Dr. Sir GD Singh',
    titleDetails: '',
    image: gdSinghImg,
    bio: [
      'Prof.Dr.Sir G D Singh is Chair of the Confederation of International Accreditation Commission- CIAC, Global Board, serving as President of CIAC- Global since Dec 2009. GD is the Founder & Managing Director of Unified Brainz Group Holdings Inc. Prior to his entrepreneurial venture with UBGHI, a dynamic personality infused with entrepreneurial spirit GD has been actively playing role in leading the Top Management & board of advisory as a Management Consultant to Leading Companies in India & Abroad; His far-sighted vision and keen business acumen provide the necessary leadership and impetus to the group activities.',
      'He is the President of the World Peace and Diplomacy Organisation-WPDO registered with the United Nations.'
    ]
  }
];

const DEFAULT_ADVISORS = [
  {
    id: 'adv-3',
    role: 'Advisor',
    name: 'HH Prof. Dr. Sir Romesh Jayasinghe',
    titleDetails: '',
    image: drRomeshImg,
    bio: [
      'Prof. Dr.Sir Romesh Jayasinghe is a Psychologist and the President of the Institute of Mental Health SL. He is the Executive Director and Peace Mediator at International Special Court of Arbitration and Human Rights IGC. He is also the Vice President and Ambassador at Large Extraordinary for South Asia and High Commissioner for Social Economy and Mental Health Science, Sri Lanka at International Commission of Diplomatic Relations Human Rights and Peace.'
    ]
  },
  {
    id: 'adv-4',
    role: 'Advisor',
    name: 'Mrs. Charmaine Eheliyagoda Madurasinghe',
    titleDetails: '',
    image: mrsCharmaineImg,
    bio: [
      'Mrs. Charmaine Eheliyagoda Madurasinghe is an Attorney-at-Law of the Supreme Court of Sri Lanka and a Notary Public. She is a Life Member of the Bar Association of Sri Lanka. She is also a Life Member of Colombo Law Society and a Member of the Executive Committee of Women Lawyers Association. Charmaine served two terms ( 2006-2009 and 2012-2015) as a Commission Member of the National Police Commission of Sri Lanka. She is an Advisor of Sanasumata Maga (Way To Comfort) NGO in Sri Lanka and a Senate Member of the United Nations University For Global Peace.',
      'Charmaine is a multi-talented, results-oriented, senior professional with excellent language skills and wide experience in planning, strategy, administration and people management, and for seven years she served as the Manager Legal HR and Administration at Sumanagiri Lanka Ltd-owning company of Cocoon Resorts in Induruwa, Kosgoda & Nuwera Eliya. She is a past pupil of St Bridget\'s Convent, Colombo, and the Vice President of the Past Pupil\'s Association ( 2015/16). She is also a Graduate of the International Institute of Theological Studies, USA. which is affiliated to the Middle East and South Asia Graduate School of Theology, a faculty of Hebron Eco University.'
    ]
  }
];

function AboutGovernance({ siteData }) {
  const [selectedMember, setSelectedMember] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setSelectedMember(null);
    };
    if (selectedMember) {
      window.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'auto';
    };
  }, [selectedMember]);

  const leadershipList = (siteData?.leadership && siteData.leadership.length > 0)
    ? siteData.leadership
    : DEFAULT_LEADERSHIP;

  const intlGovList = (siteData?.internationalGovernors && siteData.internationalGovernors.length > 0)
    ? siteData.internationalGovernors
    : DEFAULT_INTL_GOVERNORS;

  const advisorsList = (siteData?.advisors && siteData.advisors.length > 0)
    ? siteData.advisors
    : DEFAULT_ADVISORS;

  const renderMemberCard = (member) => (
    <div
      key={member.id || member.name}
      className="team-card"
      onClick={() => setSelectedMember(member)}
      role="button"
      tabIndex={0}
      itemScope
      itemType="https://schema.org/Person"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setSelectedMember(member);
        }
      }}
    >
      <div className="team-card-image-wrap">
        <img src={member.image} alt={`${member.name} - ${member.role} of UNGDO`} className="team-card-image" itemProp="image" />
      </div>
      <div className="team-card-body">
        <div className="team-card-name-row">
          <h3 className="team-card-name" itemProp="name">{member.name}</h3>
          <button
            type="button"
            className="team-card-arrow-btn"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedMember(member);
            }}
            aria-label={`View bio for ${member.name}`}
            title="View Bio"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
        <p className="team-card-role" itemProp="jobTitle">{member.role}</p>
        {member.titleDetails && (
          <p className="team-card-credentials">{member.titleDetails}</p>
        )}
      </div>
    </div>
  );

  return (
    <div className="page-shell about-subpage">
      {/* Hero Banner */}
      <div className="about-hero">
        <span className="about-hero-pill">Institutional Guidance</span>
        <h1 className="about-hero-title">Governance & Leadership Structure</h1>
        <p className="about-hero-tagline">Diplomatic Experience, Ethical Direction & Strategic Guidance</p>
        <p className="about-hero-desc">
          UNGDO is guided by an Executive Leadership and Board of Directors, complemented by an international governance and advisory structure. Our leadership brings together individuals with diverse professional, academic, diplomatic, philanthropic, and community-oriented experiences.
        </p>
      </div>

      {/* Navigation Pills */}
      <div className="about-nav-pills">
        <NavLink to="/about" className="about-pill-btn">Overview & Mission</NavLink>
        <NavLink to="/about/areas-of-focus" className="about-pill-btn">12 Areas of Focus</NavLink>
        <NavLink to="/about/strategic-pillars" className="about-pill-btn">Strategic Pillars & SDGs</NavLink>
        <NavLink to="/about/governance" className="about-pill-btn active">Governance & Leadership</NavLink>
      </div>

      {/* Executive Leadership & Board of Directors */}
      <section className="un-leadership-section">
        <div className="un-leadership-header">
          <span className="un-pill">Executive Leadership</span>
          <h2 className="un-section-title">Executive Leadership & Board of Directors</h2>
          <p className="un-section-desc">
            Meet the distinguished leaders guiding the United Nations Global Development Organization worldwide. Click any card or arrow to view the full profile and biography.
          </p>
        </div>

        <div className="team-grid">
          {leadershipList.map(renderMemberCard)}
        </div>
      </section>

      {/* International Governance & Advisory Council */}
      {(intlGovList.length > 0 || advisorsList.length > 0) && (
        <section className="un-leadership-section" style={{ marginTop: '56px' }}>
          <div className="un-leadership-header">
            <span className="un-pill">International Governance</span>
            <h2 className="un-section-title">International Governance & Advisory Council</h2>
            <p className="un-section-desc">
              UNGDO is supported by an international governance and advisory structure comprising distinguished individuals whose experience, knowledge, and perspectives contribute to the organization's broader vision and development objectives.
            </p>
          </div>

          {/* International Governors */}
          {intlGovList.length > 0 && (
            <div style={{ marginBottom: '40px' }}>
              <h3 className="un-subsection-title">International Governors</h3>
              <div className="team-grid">
                {intlGovList.map(renderMemberCard)}
              </div>
            </div>
          )}

          {/* Advisors */}
          {advisorsList.length > 0 && (
            <div>
              <h3 className="un-subsection-title">Advisors</h3>
              <div className="team-grid">
                {advisorsList.map(renderMemberCard)}
              </div>
            </div>
          )}
        </section>
      )}

      {/* Commitment to Excellence & Impact */}
      <div style={{ marginTop: '56px' }}>
        <div className="pillar-section">
          <div className="pillar-header">
            <div className="pillar-icon-wrap">💎</div>
            <div className="pillar-title-group">
              <h3>OUR COMMITMENT TO EXCELLENCE</h3>
              <span className="pillar-subtitle">Professionalism, Integrity & Ethical Conduct</span>
            </div>
          </div>
          <div className="pillar-body">
            <p>
              UNGDO is committed to pursuing its objectives with professionalism, integrity, responsibility, and respect for the communities and individuals with whom we engage.
            </p>
            <p>
              We recognize that institutional credibility is built through responsible leadership, meaningful contribution, ethical conduct, consistency, and a genuine commitment to service. Our aspiration is, therefore, not simply to establish programmes or initiatives but to cultivate an enduring platform for knowledge, cooperation, leadership, humanitarian responsibility, community empowerment, and sustainable development.
            </p>
          </div>
        </div>

        <div className="pillar-section">
          <div className="pillar-header">
            <div className="pillar-icon-wrap">⚡</div>
            <div className="pillar-title-group">
              <h3>CREATING IMPACT THROUGH COLLECTIVE ACTION</h3>
              <span className="pillar-subtitle">Meaningful Change Begins with Shared Purpose</span>
            </div>
          </div>
          <div className="pillar-body">
            <p>
              Meaningful change begins when people move beyond recognizing challenges and choose to become part of the solution.
            </p>
            <ul style={{ paddingLeft: '20px', lineHeight: 1.8, color: '#475569', marginBottom: '16px' }}>
              <li><strong>A single educational opportunity</strong> can alter the trajectory of a life.</li>
              <li><strong>A strengthened community</strong> can influence generations.</li>
              <li><strong>A meaningful partnership</strong> can connect expertise and resources that would otherwise remain apart.</li>
              <li><strong>A committed individual</strong> can inspire others to act.</li>
            </ul>
            <p>
              At UNGDO, we believe that these individual contributions become significantly more powerful when united by a shared purpose. Our commitment is to encourage a culture of service, responsibility, innovation, cooperation, and constructive engagement—creating opportunities for people and institutions to contribute to a more equitable, peaceful, resilient, and sustainable future.
            </p>
          </div>
        </div>

        <div className="pillar-section">
          <div className="pillar-header">
            <div className="pillar-icon-wrap">🚀</div>
            <div className="pillar-title-group">
              <h3>LOOKING TOWARDS THE FUTURE</h3>
              <span className="pillar-subtitle">Vision, Wisdom & Courage for the Eras Ahead</span>
            </div>
          </div>
          <div className="pillar-body">
            <p>
              The defining challenges of our era demand more than ambition. They require vision, wisdom, collaboration, courage, and responsible leadership. UNGDO looks towards the future with a commitment to strengthening meaningful partnerships, expanding educational and humanitarian engagement, empowering communities, promoting awareness of global development priorities, and encouraging responsible participation in the pursuit of sustainable progress.
            </p>
            <p>
              We believe that the true measure of development is not determined solely by economic indicators or material advancement. It is reflected in whether people are able to live with dignity, opportunity, security, equality, knowledge, and hope.
            </p>
            <div style={{ background: '#f8fafc', borderLeft: '4px solid #f9c84a', padding: '18px 24px', borderRadius: '0 8px 8px 0', marginTop: '16px' }}>
              <p style={{ margin: 0, fontStyle: 'italic', fontWeight: 600, color: '#0c2f4d', fontSize: '1.02rem', lineHeight: 1.6 }}>
                "Our journey is guided by a simple yet profound aspiration: To contribute, in every meaningful way within our mandate, to a world in which peace is strengthened, dignity is respected, communities are empowered, partnerships are purposeful, and sustainable development becomes a shared responsibility."
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Member Bio Modal Popup */}
      {selectedMember && (
        <div
          className="team-modal-backdrop"
          onClick={() => setSelectedMember(null)}
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-member-name"
        >
          <div className="team-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="team-modal-close-btn"
              onClick={() => setSelectedMember(null)}
              aria-label="Close biography modal"
              title="Close"
            >
              ✕
            </button>
            <div className="team-modal-body">
              <div className="team-modal-img-wrap">
                <img src={selectedMember.image} alt={selectedMember.name} className="team-modal-img" />
              </div>
              <div className="team-modal-text-wrap">
                <h2 id="modal-member-name" className="team-modal-name">{selectedMember.name}</h2>
                <p className="team-modal-role">{selectedMember.role}</p>
                {selectedMember.titleDetails && (
                  <p className="team-modal-credentials">{selectedMember.titleDetails}</p>
                )}
                <div className="team-modal-bio">
                  {Array.isArray(selectedMember.bio) ? (
                    selectedMember.bio.map((paragraph, idx) => (
                      <p key={idx}>{paragraph}</p>
                    ))
                  ) : (
                    <p>{selectedMember.bio}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Call to Action Banner */}
      <div className="about-cta-banner">
        <h2 className="about-cta-title">UNITED NATIONS GLOBAL DEVELOPMENT ORGANIZATION</h2>
        <p className="about-cta-text" style={{ fontSize: '1.2rem', fontWeight: 700, color: '#f9c84a' }}>
          Empowering Communities. Supporting Peace. Advancing Sustainable Development.
        </p>
        <p className="about-cta-text">
          Together, we can transform shared aspirations into meaningful action and build a future worthy of generations to come.
        </p>
        <NavLink to="/contact" className="about-cta-btn">
          Connect With Us →
        </NavLink>
      </div>
    </div>
  );
}

export default AboutGovernance;
